// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound___5hNx","notfound404":"notfound_notfound404__I3xSQ","notfound-404":"notfound_notfound-404__1_gIo"};